import { InputLabel } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { de } from "date-fns/locale";
import { useState } from "react";
export default function DatePickerStyled({
  required = false,
  name,
  label,
  value,
  disablePast = true,
  minDate,
  maxDate,
  onChange,
}) {
  const [open, setOpen] = useState(false);
  const handleDateChanged = (value) => {
    if (onChange && typeof onChange === "function") {
      onChange(value);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={de}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <DatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        views={["year", "month", "day"]}
        label={label}
        name={name}
        disablePast={disablePast}
        minDate={minDate}
        maxDate={maxDate}
        value={value}
        onChange={(newValue) => {
          handleDateChanged(newValue);
        }}
        sx={{
          width: "100%",
          "& .MuiInputBase-input": {
            cursor: "pointer",
          },
          "& .MuiInputLabel-root": {
            display: "none",
          },
        }}
        slotProps={{
          textField: {
            onClick: () => setOpen(true),
            required: required,
            variant: "filled",
            InputLabelProps: {
              shrink: true,
            },
            inputProps: {
              readOnly: true,
            },
          },
          field: {
            clearable: true,
            onClear: () => handleDateChanged(null),
          },
        }}
        localeText={{
          toolbarTitle: "Datum auswählen",
          cancelButtonLabel: "Abbrechen",
          okButtonLabel: "OK",
        }}
      />
    </LocalizationProvider>
  );
}
